export default __webpack_public_path__ + "static/media/imageLogisticsContentTwo.cb1f5bd7.png";